import React from 'react'
import { useTranslation } from 'react-i18next'
import { RecruitmentStatCard } from './RecruitmentStatCard'
import { formatSavedTime } from '../utils/formatSavedTime'

interface DashboardRecruitmentStatsProps {
  analyzedCvCount: number
  offersCount: number
  matchingCount: number
  manualMatchingTimeMinutes: number
  timeSavedMinutes: number
  interviewTimeSavedMinutes: number
  interviewRetainedPercent: number
  hiredCandidatesCount: number
  aiInterviewCount: number
  footerLabel: string
}

export function DashboardRecruitmentStats({
  analyzedCvCount,
  offersCount,
  matchingCount,
  manualMatchingTimeMinutes,
  timeSavedMinutes,
  interviewTimeSavedMinutes,
  interviewRetainedPercent,
  hiredCandidatesCount,
  aiInterviewCount,
  footerLabel,
}: DashboardRecruitmentStatsProps) {
  const { t } = useTranslation()

  const stats = [
    {
      title: t('dashboard.recruitmentStats.cvAnalyzedTitle'),
      value: analyzedCvCount.toString(),
      footerLabel,
      description: t('dashboard.recruitmentStats.cvAnalyzedDescription'),
      // deltaLabel: '+2%',
      deltaPositive: true,
    },
    {
      title: t('dashboard.recruitmentStats.offersCountTitle'),
      value: offersCount.toString(),
      footerLabel,
      description: t('dashboard.recruitmentStats.offersCountDescription'),
      // deltaLabel: '+2%',
      deltaPositive: true,
    },
    {
      title: t('dashboard.recruitmentStats.matchingCountTitle'),
      value: matchingCount.toString(),
      footerLabel,
      description: t('dashboard.recruitmentStats.matchingCountDescription'),
      showDelta: false,
    },
    {
      title: t('dashboard.recruitmentStats.interviewRetainedTitle'),
      value: `${interviewRetainedPercent}%`,
      footerLabel,
      description: t('dashboard.recruitmentStats.interviewRetainedDescription'),
      // deltaLabel: '+2%',
      deltaPositive: true,
    },
    {
      title: t('dashboard.recruitmentStats.aiInterviewsTitle'),
      value: aiInterviewCount.toString(),
      footerLabel,
      description: t('dashboard.recruitmentStats.aiInterviewsDescription'),
      showDelta: false,
    },
    {
      title: t('dashboard.recruitmentStats.hiredCandidatesTitle'),
      value: hiredCandidatesCount.toString(),
      footerLabel,
      description: t('dashboard.recruitmentStats.hiredCandidatesDescription'),
      showDelta: false,
    },
    {
      title: t('dashboard.recruitmentStats.timeSavedTitle'),
      value: formatSavedTime(timeSavedMinutes),
      footerLabel,
      description: t('dashboard.recruitmentStats.timeSavedDescription', {
        minutes: manualMatchingTimeMinutes,
      }),
      hint: t('dashboard.recruitmentStats.manualMatchingTimeHint', {
        minutes: manualMatchingTimeMinutes,
      }),
      hintHref: '/settings?tab=dashboard',
      hintState: { manualMatchingTimeMinutes },
      // deltaLabel: '+2%',
      deltaPositive: true,
    },
    {
      title: t('dashboard.recruitmentStats.interviewTimeSavedTitle'),
      value: formatSavedTime(interviewTimeSavedMinutes),
      footerLabel,
      description: t('dashboard.recruitmentStats.interviewTimeSavedDescription'),
      showDelta: false,
    },
    // {
    //   title: t('dashboard.recruitmentStats.hiredCandidatesTitle'),
    //   value: hiredCandidatesCount.toString(),
    //   footerLabel,
    //   showDelta: false,
    // },
    // {
    //   title: t('dashboard.recruitmentStats.aiInterviewsTitle'),
    //   value: aiInterviewCount.toString(),
    //   footerLabel,
    //   showDelta: false,
    // },
  ] as const

  // On large screens, let cards grow with available width.
  return (
    <section
      className="box-border flex w-full min-w-0 flex-col gap-2"
      aria-label="Indicateurs de recrutement"
    >
      <div className="grid w-full grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <RecruitmentStatCard key={stat.title} {...stat} />
        ))}
      </div>
    </section>
  )
}
